/**
 * Theoretical one-rep max estimators.
 *
 * Epley (1985):  1RM = weight × (1 + reps/30)
 *
 * Accurate up to ~10 reps; widely used by lifters and strength coaches.
 */

export function epley1RM(weightKg, reps) {
  const w = Number(weightKg) || 0;
  const r = Number(reps) || 0;
  if (w <= 0 || r <= 0) return 0;
  if (r === 1) return w;
  return w * (1 + r / 30);
}

/**
 * Returns the highest theoretical 1RM across an array of sets
 * (each with `weight_kg` and `reps`).
 */
export function bestEstimated1RM(sets) {
  let best = 0;
  (sets || []).forEach((s) => {
    const e = epley1RM(s.weight_kg, s.reps);
    if (e > best) best = e;
  });
  return best;
}
